<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="d-flex flex-column flex-center flex-column-fluid p-10 text-center"
    >
      <div class="mb-10">
        <i
          class="fas fa-exclamation-triangle text-warning"
          style="font-size: 4rem"
        ></i>
      </div>
      <h3 class="font-weight-bolder text-dark mb-5">Erro no Login Integrado</h3>
      <p class="text-muted font-size-h5 mb-10 px-10">{{ mensagem }}</p>
      <div>
        <a
          :href="loginUrl"
          class="btn btn-primary font-weight-bolder px-8 py-3"
        >
          Tentar novamente
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SSOErro",
  computed: {
    mensagem() {
      return (
        this.$route.query.message ||
        "Ocorreu um erro durante a autenticação. Entre em contato com o suporte."
      );
    },
    loginUrl() {
      return process.env.BASE_URL + "login";
    }
  }
};
</script>
